import mapboxgl from 'mapbox-gl';
import $ from 'jquery';

// $(document).ready(function() {
//   console.log(mapbox_params)
//   console.log(mapbox_params.lat)
//   console.log('yo')
//   //mapboxgl.accessToken = 'pk.eyJ1Ijoia2F0ZWJlcmdoIiwiYSI6ImNrYzY3Y3BqaTA4bnAydm54dW5lajE0c2UifQ.6dbz6dJAykGStnkQTQzYbQ';
//   // eslint-disable-next-line no-undef
//   mapboxgl.accessToken = mapbox_params.api_key
//   const center = [mapbox_params.lng, mapbox_params.lat]
//   console.log(center)
//   // var map = new mapboxgl.Map({
//   //   container: 'map', // container id
//   //   style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
//   //   center: [12.550343, 55.665957], // starting position [lng, lat]
//   //   zoom: 8, // starting zoom
//   // });
//   var map = new mapboxgl.Map({
//     container: 'map', // container id
//     style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
//     center: center, // starting position [lng, lat]
//     zoom: 16, // starting zoom
//   });
//   // new mapboxgl.Marker()
//   //   .setLngLat([12.550343, 55.665957])
//   //   .addTo(map);
//   new mapboxgl.Marker()
//     .setLngLat(center)
//     .addTo(map);
// })
/*
jQuery(document).ready(function() {

  // eslint-disable-next-line no-undef
  mapboxgl.accessToken = 'pk.eyJ1Ijoia2F0ZWJlcmdoIiwiYSI6ImNrYzY3Y3BqaTA4bnAydm54dW5lajE0c2UifQ.6dbz6dJAykGStnkQTQzYbQ';
  if(jQuery('.map-wrapper').length) {

    jQuery('.map-wrapper').each(function(){

      var $this = jQuery(this);
      var features = jQuery.parseJSON($this.find('.mappins').text());

      // init map
      var map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v11',
        zoom: 3,
      });

      map.on('load', function() {

        map.addSource('places', {
          'type': 'geojson',
          'data': {
            'type': 'FeatureCollection',
            'features': features,
          },
        });

        map.addLayer({
          'id': 'places',
          'type': 'symbol',
          'source': 'places',
          'layout': {
            'icon-image': '{icon}-15',
            'icon-allow-overlap': true,
          },
        });

      });



      // Centering
      //first coordinate in features
      let co = features[0].geometry.coordinates;

      // we want to determine the bounds for the features data
      let bounds = features.reduce((bounds, feature) => {
        return bounds.extend(feature.geometry.coordinates);
      }, new mapboxgl.LngLatBounds(co[0].lng, co[0].lat));

      // set bounds according to features
      map.fitBounds(bounds, {
        padding: 50,
        maxZoom: 14.15,
        duration: 2000,
      });


      // When a click event occurs on a feature in the places layer, open a popup at the
      // location of the feature, with description HTML from its properties.
      map.on('click', 'places', function(e) {
        var coordinates = e.features[0].geometry.coordinates.slice();
        var description = e.features[0].properties.description;

        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        new mapboxgl.Popup()
          .setLngLat(coordinates)
          .setHTML(description)
          .addTo(map);
      });

      // Change the cursor to a pointer when the mouse is over the places layer.
      map.on('mouseenter', 'places', function() {
        map.getCanvas().style.cursor = 'pointer';
      });

      // Change it back to a pointer when it leaves.
      map.on('mouseleave', 'places', function() {
        map.getCanvas().style.cursor = '';
      });



    });

  }
});
*/


$(window).on('load', function(){

  // eslint-disable-next-line no-undef
  mapboxgl.accessToken = 'pk.eyJ1Ijoia2F0ZWJlcmdoIiwiYSI6ImNrYzY3Y3BqaTA4bnAydm54dW5lajE0c2UifQ.6dbz6dJAykGStnkQTQzYbQ';
  // mapboxgl.accessToken = 'sk.eyJ1Ijoia2F0ZWJlcmdoIiwiYSI6ImNsbzNmbDBzbjE2c20yaXF1dmt3YTB4YXEifQ.2_jeL5RXe-NwsWPbLNCDUw';
	
  const data_object = $('#map').attr('data-object')
  const data_object_type = $('#map').attr('data-object-type')
  const data_object_id = $('#map').attr('data-object-id')
  const url = '/wp-json/wetu/v1/mapbox?' + 'object=' + data_object + '&object_type=' + data_object_type + '&object_id=' + data_object_id

  $.ajax({
    url: url,
    type: 'get',
    success: function (result) {

      // console.log('map');
      if (result.error === false) {
        const features = result.data
        /* eslint-disable */
        // console.log(features)
        const props = ['accommodation', 'experience', 'holiday','destination']


        const icons = {
          'accommodation': 'lodging-15',
          'experience': 'veterinary-15',
          'holiday': 'beach-15',
          'destination': 'airport-15',
        }


        // eslint-disable-next-line no-undef
        var map = new mapboxgl.Map({
          container: 'map',
          //style: 'mapbox://styles/mapbox/streets-v11',
          style: 'mapbox://styles/mapbox/light-v10',
          zoom: 3,
        });




        // let icon = '{icon}-15'

        // icon = 'lodging-15'
        for (let i = 0; i < props.length; i += 1) {
          let prop = props[i]

          map.on('load', function () {
            if (features.hasOwnProperty(prop) === true) {

              // console.log('here v');
              // console.log(features[prop][i].properties);
              // console.log('here ^');

              map.loadImage( mapbox_params.iconpath + 'default-pin.png',
                function (error, image) {
                  if (error) throw error;
                  map.addImage('default-destination', image);
                }
              );
              map.loadImage( mapbox_params.iconpath + 'default-pin.png',
                function (error, image) {
                  if (error) throw error;
                  map.addImage('main-destination', image);
                }
              );
              map.loadImage(mapbox_params.iconpath + 'default-pin.png',
                function (error, image) {
                  if (error) throw error;
                  map.addImage('default-accommodation', image);
                }
              );
              map.loadImage(mapbox_params.iconpath + 'default-pin.png',
                function (error, image) {
                  if (error) throw error;
                  map.addImage('main-accommodation', image);
                }
              );

              var prefix = 'default';
              // jQuery(features[prop]).each(function(i){
              //   if(features[prop][i].properties.id == mapbox_params.mainid) {
              //     var prefix = 'main';
              //   }else {
              //     var prefix = 'default';
              //   }
              // });

              map.addSource(prop, {
                'type': 'geojson',
                'data': {
                  'type': 'FeatureCollection',
                  'features': features[prop],
                },
              });
              map.addLayer({
                'id': prop,
                'type': 'symbol',
                'source': prop,
                'layout': {
                  'icon-image': prefix + '-' + prop,
                  'icon-allow-overlap': true,
                  'icon-size':0.5,
                }
              });

              let co = features[prop][0].geometry.coordinates;

              // we want to determine the bounds for the features data
              let bounds = features[prop].reduce((bounds, feature) => {
                return bounds.extend(feature.geometry.coordinates);
              }, new mapboxgl.LngLatBounds(co[0].lng, co[0].lat));

              // set bounds according to features
              map.fitBounds(bounds, {
                padding: 50,
                maxZoom: 14.15,
                duration: 2000,
              });


              // When a click event occurs on a feature in the places layer, open a popup at the
              // location of the feature, with description HTML from its properties.
              map.on('click', prop, function (e) {
                var coordinates = e.features[0].geometry.coordinates.slice();
                var title = e.features[0].properties.title;
                var description = e.features[0].properties.description;
                var image = e.features[0].properties.image;
                var destination = e.features[0].properties.destination;
                var price = e.features[0].properties.price;
                var permalink = e.features[0].properties.permalink;
                var url = e.features[0].properties.url;
                var urltext = e.features[0].properties.urltext;


                var html = '<div class="map-info">';

                if(typeof image != 'undefined' && image !== 'null') {
                  html += '<a href="' + permalink + '"><div class="map-image"><img src="' + image + '" /></div></a>';
                }

                html += '<div class="map-content">';
                html += '<h4><a href="' + permalink + '">' + title + '</a></h4>';
                if(typeof destination != 'undefined' && destination !== 'null' && destination !== '') {
                  html += '<span class="destination"><small>Location</small><em>' + destination + '</em></span>';
                }
                if(typeof price != 'undefined' && price !== 'null' && price !== '') {
                  html += '<span class="price"><small>From Price</small><em>' + price + '</em></span>';
                }

                html += '<a class="btn btn-primary" href="' + url + '">' + urltext + '</a>';

                // html += description;

                html += '</div></div>';

                //console.log(e.features[0].properties);

                // Ensure that if the map is zoomed out such that multiple
                // copies of the feature are visible, the popup appears
                // over the copy being pointed to.
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                  coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }

                new mapboxgl.Popup()
                  .setLngLat(coordinates)
                  .setHTML(html)
                  .addTo(map);


                  var negitive = coordinates[1] - 0.3;
                  console.log(e.features[0].geometry.coordinates);
                  map.flyTo({
                    center: e.features[0].geometry.coordinates
                    //center: [coordinates[0], negitive]
                  });

              });

              // Change the cursor to a pointer when the mouse is over the places layer.
              map.on('mouseenter', prop, function () {
                map.getCanvas().style.cursor = 'pointer';
              });

              // Change it back to a pointer when it leaves.
              map.on('mouseleave', prop, function () {
                map.getCanvas().style.cursor = '';
              });

              map.addControl(new mapboxgl.NavigationControl());

            }
          })
        }

      }
    },
    error: function (error) {
      console.log(error)
    },
  })
})



// WEBPACK FOOTER //
// ./scripts/mapbox.js